// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD1vvGWupWEE8590hpNIeEC2vHY0wXBSyI",
  authDomain: "orderly-b495c.firebaseapp.com",
  projectId: "orderly-b495c",
  storageBucket: "orderly-b495c.firebasestorage.app",
  messagingSenderId: "17505907818",
  appId: "1:17505907818:web:03c837ca582f2d8fe04613",
  measurementId: "G-4MTB8XQSKP",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const db = getFirestore(app);
const auth = getAuth(app);
